import { render, staticRenderFns } from "./mrc_ess_skLoaders.vue?vue&type=template&id=270052cd&scoped=true&"
import script from "./mrc_ess_skLoaders.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_skLoaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270052cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
